import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";
import type { CascaderOption } from "./types";

type ValueType = Array<string | number> | null;

interface Props {
  modelValue?: ValueType;
  options?: CascaderOption[];
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  showSearch?: boolean;
  changeOnSelect?: boolean;
  expandTrigger?: "click" | "hover";
  status?: "" | "error" | "warning";
  separator?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Cascader',
  props: {
    modelValue: { default: null },
    options: { default: () => [] },
    placeholder: { default: "Chọn..." },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    showSearch: { type: Boolean, default: true },
    changeOnSelect: { type: Boolean, default: false },
    expandTrigger: { default: "click" },
    status: { default: "" },
    separator: { default: " / " }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const removeAccent = (str: string) =>
  str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

const showSearchConfig = computed(() => {
  if (!props.showSearch) return false;
  return {
    filter: (inputValue: string, path: CascaderOption[]) =>
      path.some((opt) => removeAccent(String(opt.label)).includes(removeAccent(inputValue))),
  };
});

const displayRender = ({ labels }: { labels: string[] }) => labels.join(props.separator);

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: ValueType) => {
    emit("update:modelValue", val);
  },
});

const onChange = (val: ValueType, selectedOptions?: CascaderOption[]) => {
  emit("update:modelValue", val);
  emit("change", val, selectedOptions);
};

return (_ctx: any,_cache: any) => {
  const _component_a_cascader = _resolveComponent("a-cascader")!

  return (_openBlock(), _createBlock(_component_a_cascader, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    options: _ctx.options,
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    "show-search": showSearchConfig.value,
    "change-on-select": _ctx.changeOnSelect,
    "expand-trigger": _ctx.expandTrigger,
    status: _ctx.status,
    "display-render": displayRender,
    class: "ant-cascader",
    onChange: onChange
  }, null, 8, ["value", "options", "placeholder", "disabled", "size", "allow-clear", "show-search", "change-on-select", "expand-trigger", "status"]))
}
}

})